import request from '@/utils/request'

const urlPrefix = '/service-health'

export function getServiceHealthItemList (params) {
  return request.get(`${urlPrefix}/items`, { params })
}

export function getServiceHealthDimension (id) {
  return request.get(`${urlPrefix}/dimensions/${id}`)
}

export function createServiceHealthDimension (data) {
  return request.post(`${urlPrefix}/dimensions`, data)
}

export function getServiceHealthDimensionList (params) {
  return request.get(`${urlPrefix}/dimensions/tree`, { params })
}

export function updateServiceHealthDimension (id, data) {
  return request.put(`${urlPrefix}/dimensions/${id}`, data)
}

export function deleteServiceHealthDimension (id) {
  return request.delete(`${urlPrefix}/dimensions/${id}`)
}

export function getServiceHealthIndicator (id) {
  return request.get(`${urlPrefix}/indicators/${id}`)
}

export function createServiceHealthIndicator (data) {
  return request.post(`${urlPrefix}/indicators`, data)
}

export function getServiceHealthIndicatorList (params) {
  return request.get(`${urlPrefix}/indicators`, { params })
}

export function updateServiceHealthIndicator (id, data) {
  return request.put(`${urlPrefix}/indicators/${id}`, data)
}

export function deleteServiceHealthIndicator (id) {
  return request.delete(`${urlPrefix}/indicators/${id}`)
}
